import { render, staticRenderFns } from "./fieldVision.vue?vue&type=template&id=2354c3d3&scoped=true&"
import script from "./fieldVision.vue?vue&type=script&lang=js&"
export * from "./fieldVision.vue?vue&type=script&lang=js&"
import style0 from "./fieldVision.vue?vue&type=style&index=0&id=2354c3d3&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2354c3d3",
  null
  
)

export default component.exports